var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row mb-6"},[_vm._m(0),_c('div',{staticClass:"vx-col sm:w-5/6 w-full"},[_c('vs-input',{attrs:{"type":"text","value":_vm.mutableBudgetQuota,"disabled":""}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col sm:w-1/6 w-full"},[_c('span',[_vm._v("Budget Quota")])])
}]

export { render, staticRenderFns }